import React from 'react';
import ReactDOM from 'react-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {META_SITE_NAME, META_SITE_NAME_DESC, META_SITE_NAME_DNS, META_TITLE, TITLE} from './config/site.config';
import './index.css';

const appWrapper = (
  <HelmetProvider>
    <Helmet>
      <meta property="og:title" content={META_TITLE} />
      <meta property="og:site_name" content={META_SITE_NAME} />
      <meta property="og:url" content={META_SITE_NAME_DNS} />
      <meta property="og:description" content={META_SITE_NAME_DESC} />
      <meta property="og:image" content={`${META_SITE_NAME_DNS}/logoSharedLink.png`} />
      <meta property="og:image:width" content="256" />
      <meta property="og:image:height" content="256" />
      <title>{TITLE}</title>
    </Helmet>
    <App />
  </HelmetProvider>
);

ReactDOM.render(appWrapper, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
